module.exports = __webpack_public_path__ + "static/media/leaf-maple.3d09abce.svg";